import type { HTMLAttributes, ReactNode } from "react"
import type { ClassValue } from "clsx"

import { cn } from "@/lib/utils"

type MarketingAlertVariant = "error" | "info" | "success"

const VARIANT_CLASS: Record<MarketingAlertVariant, string> = {
  error: "border-[var(--color-vermilion)]",
  info: "border-l-[3px] border-l-[var(--color-ink-muted)]",
  success: "border-l-[3px] border-l-[var(--color-ink)]",
}

type MarketingAlertProps = Omit<HTMLAttributes<HTMLDivElement>, "className" | "role"> & {
  children: ReactNode
  className?: ClassValue
  role?: "alert" | "status"
  variant?: MarketingAlertVariant
}

export function MarketingAlert({
  children,
  className,
  role = "alert",
  variant = "error",
  ...props
}: MarketingAlertProps) {
  return (
    <div
      role={role}
      className={cn(
        "rounded-[8px] border border-[var(--color-rule)] bg-[var(--color-paper-high)] px-4 py-3 text-[0.9rem] leading-[1.5] text-[var(--color-ink)]",
        VARIANT_CLASS[variant],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
